module.exports = __webpack_public_path__ + "static/media/GH.037ebbd2.svg";